import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import useUser from '../hooks/global/useUser';
import { isUserEmployeeOrAdmin } from '../utils/global/helper';
import { LoadedUser } from '../interfaces';

export default function NoAccountPage() {
  const navigate = useNavigate();
  const { user } = useUser();

  React.useEffect(() => {
    const isValidUser =
      user && user.business && isUserEmployeeOrAdmin(user as LoadedUser);
    if (isValidUser) {
      navigate('/');
    }
  }, [navigate, user]);

  return (
    <Box
      p={4}
      boxSizing="border-box"
      sx={{
        display: 'flex',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        paddingInline: '1rem',
      }}>
      <div className="sign-up">
        <div className="text">
          <Typography variant="h1" align="center">
            Couldn&apos;t find your account
          </Typography>
          <Typography variant="body1" align="center">
            If you are a tattoo artist or studio manager / owner, sign up
            through our website below to get started today!
          </Typography>
        </div>
        <Button
          variant="contained"
          className="primary"
          href="https://getporter.io/">
          Get Started
        </Button>
        <Button
          variant="text"
          className="text-btn"
          onClick={() => auth.signOut().then(() => navigate('/'))}>
          Sign in with a different phone number
        </Button>
      </div>
    </Box>
  );
}
